module.exports={author:"Jenny Qi",date:"11/10/2019",publishDate:"11/10/2019",highlighted:!1,tags:"",title:"When This Is All Over"};